import apiService from './api';
class OrcamentosService {
    // Listar orçamentos
    async list(filters = {}) {
        const params = new URLSearchParams();
        Object.entries(filters).forEach(([key, value]) => {
            if (value !== undefined && value !== '') {
                params.append(key, String(value));
            }
        });
        const response = await apiService.get(`/orcamentos?${params}`);
        return response.data;
    }
    // Buscar orçamento por ID
    async getById(id) {
        const response = await apiService.get(`/orcamentos/${id}`);
        return response.data;
    }
    // Criar orçamento
    async create(data) {
        const response = await apiService.post('/orcamentos', data);
        return response.data;
    }
    // Atualizar orçamento
    async update(id, data) {
        const response = await apiService.put(`/orcamentos/${id}`, data);
        return response.data;
    }
    // Excluir orçamento
    async delete(id) {
        await apiService.delete(`/orcamentos/${id}`);
    }
    // Aprovar orçamento
    async approve(id) {
        const response = await apiService.patch(`/orcamentos/${id}/approve`);
        return response.data;
    }
    // Rejeitar orçamento
    async reject(id) {
        const response = await apiService.patch(`/orcamentos/${id}/reject`);
        return response.data;
    }
    // Enviar orçamento
    async send(id) {
        const response = await apiService.patch(`/orcamentos/${id}/send`);
        return response.data;
    }
}
export default new OrcamentosService();
